import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the googleVerify state domain
 */

const selectGoogleVerifyDomain = state => state.googleVerify || initialState;

const makeSelectGoogleVerifyState = () =>
  createSelector(selectGoogleVerifyDomain, subState => subState);

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectGoogleVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectGoogleVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
